import { Email, useEmailStore } from "../stores/emailStore";
import { showToast } from "../stores/toastStore";

/**
 * Borra (o "mueve a Papelera") un conjunto de correos con opción de Deshacer,
 * siguiendo el patrón de los clientes de correo modernos:
 *
 *  1. Quita los correos de la vista al instante (optimista).
 *  2. Muestra un snackbar "Deshacer" durante unos segundos.
 *  3. Si el usuario NO deshace, ejecuta la operación real en el server (`doDelete`).
 *  4. Si el usuario deshace, restaura los correos en la lista y cancela la operación.
 *
 * Esto evita tener que adivinar el nombre de la carpeta de Papelera en el server
 * para deshacer: como el borrado real aún no ha ocurrido, restaurar es puramente local.
 */
export function deleteEmailsWithUndo(
  emails: Email[],
  doDelete: () => void | Promise<unknown>,
  opts?: { message?: string }
) {
  if (!emails || emails.length === 0) return;

  const ids = emails.map((e) => e.id);
  const store = useEmailStore.getState();

  // 1. Quitar de la vista al instante (optimista)
  store.removeEmails(ids);

  // 2. Programar el borrado real en el server (solo si no se deshace)
  const timer = setTimeout(() => {
    try {
      doDelete();
    } catch (err) {
      console.error("Error al mover correos a Papelera:", err);
    }
  }, 6000);

  // 3. Snackbar con Deshacer
  showToast(opts?.message || "Correo(s) movido(s) a Papelera", {
    onUndo: () => {
      clearTimeout(timer);
      useEmailStore.getState().restoreDeletedEmails(emails);
    },
  });
}
